import { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { PortalModal } from '../../common/components';

const styles = theme => ({
    inactivityMessage: {
        padding: theme.spacing(3),
    },
});

const InactivityAlert = ({
    classes, translate, timeoutInMinutes, idleTimer,
}) => {
    const [showInactivityAlert, setShowInactivityAlert] = useState(false);

    useEffect(() => {
        let alertTimer = null;
        if (timeoutInMinutes && idleTimer) {
            alertTimer = setTimeout(() => setShowInactivityAlert(true), (timeoutInMinutes - 1) * (60 * 1000));
        }
        return () => {
            clearTimeout(alertTimer);
        };
    }, [timeoutInMinutes, idleTimer]);

    const closeAlert = () => {
        setShowInactivityAlert(false);
    };

    return (
        <PortalModal heading={translate('inactivity')} open={showInactivityAlert} onClose={closeAlert}>
            <div className={classes.inactivityMessage}>
                <Typography variant="body1">{translate('inactivityMessage')}</Typography>
            </div>
        </PortalModal>
    );
};

InactivityAlert.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    timeoutInMinutes: PropTypes.number.isRequired,
    idleTimer: PropTypes.number,
};

InactivityAlert.defaultProps = {
    idleTimer: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(InactivityAlert)));
